import { FC } from "react";

import { FacetComponentProps } from "@components/Search/SearchResults/StateComponents/Facets/Facet/@types/facet.types";
import { FacetType } from "@components/Search/SearchResults/StateComponents/Facets/Facet/@types/facetType.types";
import { ColorswatchFacet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/ColorswatchFacet/colorswatchFacet.container";
import { DefaultFacet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/DefaultFacet/defaultFacet.container";
import { HierarchicalFacet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/HierarchicalFacet/hierarchicalFacet.container";
import { NumericFacet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/NumericFacet/numericFacet.container";
import { UnitRangeFacet } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/UnitRangeFacet/unitRangeFacet.container";

const facetTypeToComponentMap = {
    [FacetType.DEFAULT]: DefaultFacet,
    [FacetType.NUMERIC]: NumericFacet,
    [FacetType.COLORSWATCH]: ColorswatchFacet,
    [FacetType.UNIT_RANGE]: UnitRangeFacet,
    [FacetType.HIERARCHICAL]: HierarchicalFacet,
} as const;

const getComponentForFacetType = <TFacetType extends FacetType>(
    facetType: TFacetType,
) => facetTypeToComponentMap[facetType] as FC<FacetComponentProps<TFacetType>>;

export { getComponentForFacetType };
